import e from "./index814.js";
import o from "./index815.js";
var t = Object.prototype, a = t.hasOwnProperty, n = t.propertyIsEnumerable, c = e(/* @__PURE__ */ (function() {
  return arguments;
})()) ? e : function(r) {
  return o(r) && a.call(r, "callee") && !n.call(r, "callee");
};
export {
  c as default
};
